import { 
         Dialog, 
         DialogActions, 
         IconButton, 
         styled, 
         Typography
       }                  from "@mui/material"
import styles             from './BglDialogStyles.module.scss'
import CloseIcon          from '@mui/icons-material/Close'

export const BglDialog = styled(Dialog)(({ theme }) => ({

  '.MuiDialog-paper': {
    background: theme.palette.background.paper,
    minWidth: '400px',
    [theme.breakpoints.down('sm')] : {
      minWidth: 0,
      maxWidth: 'none'
    }
  },

  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))


export interface DialogTitleProps {
  title : string
  onClose: (event : any, reason ?: string) => void
}

export const BglDialogTitle = (props: DialogTitleProps) => {
  const { title, onClose, ...other } = props

  return (
    <div className={styles.dialogHeaderCont} {...other}>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={(event) => onClose(event)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
      ) : null}
      <Typography 
        variant="bglTitle4"
        sx={{ textAlign: 'left' }} 
        className={styles.dialogHeader}>{title}
      </Typography>
      
    </div>
  )
}

export const BglDialogActions = styled(DialogActions)(({theme}) => ({

  display: 'flex',
  margin: '0px 10px',
  marginBottom: '20px'
}))
